import * as React from "react";
// import Modal from "../Modal";
import { Button } from "@progress/kendo-react-buttons";
import { useState, useEffect, useCallback, useRef } from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { Form, FormElement } from "@progress/kendo-react-form";
// import { addTimeFunctionality } from "actions/time.action";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Input } from "@progress/kendo-react-inputs";
import * as api from "../../api/index";
import { Label } from "@progress/kendo-react-labels";
import { DocumentsUpload } from "../Postings/DcoumentsUpload";
import { onFileUpload } from "../../services/fileDataService";
import { TextArea } from "@progress/kendo-react-inputs";
import MattersCombobox from "../Postings/MattersComboBox";
import Modalposting from "../Postings/PostingModal";
import CONSTANT from "CONSTANT/Matter/ComboxType";
import { useUploadForm } from "../../components/fileUploadHook";
import { getOfficeCreditMatterList } from "services/postingsService";
import { FILES_CONTEXT, useFiles } from "services/filesDownloadService";
import OfficeCreditGrid from "./OfficeCreditAndAllocationGrid";
import SearchComboBox from "components/common/SearchComboBox";
import { toast } from "react-toastify";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { TransactionPeriod } from "components/common/TransactionPeriod";
import { getSelectedSessionPeriodNumber } from "services/transactionPeriodService";

const toCents = (n) => Math.round((Number(n) || 0) * 100);

const OfficeCreditAndAllocations = (props) => {
  const date = new Date();
  const [details, setDetails] = useState("");
  const [reference, setReference] = useState("");
  const [payer, setPayer] = useState("");
  const [rate, setRate] = useState("");
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dateselector, setdateselector] = useState(date);
  const [matterRef, setmatterref] = useState();
  const [officevalue, setofficevalue] = useState();
  const [allocation, setAllocation] = useState(null);
  const [resetmatter, setresetmatter] = useState(false);
  const [modalvalue, setmodalvalue] = useState(false);
  const [error, setError] = useState(undefined);
  const [resetDocs, setresetDocs] = useState(false);
  const [feeearnerref, setfeeearnerref] = useState();
  const [initialData, setInitialData] = useState({
    date: new Date(Date.now()),
  });
  const [validationError, setValidationError] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [officeCreditList, setOfficeCreditList] = useState([]);

  const amountRef = useRef(amount);
  useEffect(() => {
    amountRef.current = amount;
  }, [amount]);

  const updateAllocations = useCallback((value) => {
    setAllocation(value);
  }, []);

  const handleSelectedData = useCallback((value) => {
    setSelectedData(value);
  }, []);

  const { files: filesCurrentData, clearFile } = useFiles(
    FILES_CONTEXT.OFFICE_CREDIT_ALLOCATION,
  );

  useEffect(() => {
    return () => {
      setOfficeCreditList([]);
    };
  }, []);

  const onChangematter = async (event) => {
    if (event.value !== null) {
      setOfficeCreditList([]);
      setmatterref(event?.value?.matterId);
      try {
        const list = await getOfficeCreditMatterList(event.value.matterId);
        setOfficeCreditList(list);
      } catch (error) {
        // Error already handled by API
      }
    } else {
      setOfficeCreditList([]);
    }
  };

  const onChangedateselect = (event) => {
    setdateselector(event.value);
  };

  const isSelected = selectedData?.some((item) => item.add === true);
  useEffect(() => {
    if (isSelected && validationError) {
      setValidationError(false);
    }
  }, [isSelected]);

  async function handleSubmit(values) {
    const selectedTransactionPeriod = getSelectedSessionPeriodNumber();

    const data = [
      {
        postingType: "OCR",
        matterID: matterRef,
        feeEarnerRef: values?.feeEarner?.userRef,
        date: dateselector,
        netAmount: amount,
        transactionPeriod: selectedTransactionPeriod,
        currencyCode: "GBP",
        details: details,
        reference: reference,
        payer: payer,
        OfficeBank: values?.officeBank?.nominalRef,
      },
    ];

    const requiredFields = [
      matterRef,
      details,
      reference,
      payer,
      values?.officeBank?.nominalRef,
      values?.feeEarner?.userRef,
    ];

    if (isSelected) {
      if (amount == 0) {
        setValidationError(false);
      } else if (requiredFields.some((field) => !field)) {
        setValidationError(true);
        return;
      } else {
        setValidationError(false);
      }
    } else {
      if ([amount, ...requiredFields].some((field) => !field)) {
        setValidationError(true);
        return;
      }
    }

    if (allocation !== null) {
      data[0].allocations = allocation;
    }
    if (filesCurrentData[0] !== undefined) {
      const docsId = [];
      filesCurrentData.forEach((item) => {
        docsId.push(item.fileID);
      });
      data[0].DocumentFiles = docsId;
    }
    if (isSelected && allocation?.length > 0) {
      const totalAllocatedMinorUnits = allocation.reduce(
        (sum, item) => sum + toCents(item.amount),
        0,
      );
      if (totalAllocatedMinorUnits !== toCents(amount)) {
        return toast.error("Allocated amount should be equal to the Net amount");
      }
    }

    try {
      setLoading(true);
      const response = await api.createposting(data);
      toast.success(
        `Posted Successfully for ${response?.data?.data[0]?.postingType} - ${response?.data?.data[0]?.transactionNo} `,
      );
      reset();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }
  const reset = async () => {
    setOfficeCreditList([]);
    setDetails("");
    setfeeearnerref(null);
    setofficevalue(null);
    setAmount(0);
    setPayer("");
    setReference("");
    setRate("");
    // setresetmatter(!resetmatter);
    setresetDocs(!resetDocs);
    try {
      const list = await getOfficeCreditMatterList(matterRef);
      setOfficeCreditList(list);
    } catch (error) {
      // Error already handled by API
    }
    setError(false);
    clearFile();
  };

  const { isSuccess, uploadForm, progress } = useUploadForm();

  const [filesData, setFilesData] = React.useState([]);

  const handleUpload = async (e) => {
    let data = onFileUpload(e);
    setFilesData([...filesData, data]);

    const parameters = {
      documentType: "Posting",
      matterId: matterRef || "",
    };
    const dataChoosen = await uploadForm(data, e.target.files[0], parameters);
    data.fileID = dataChoosen.data.data.fileID;
  };
  const onFileRemove = (fileId) => {
    setFilesData((prev) => prev.filter((file) => file.fileID !== fileId));
  };

  return (
    <div className="h-100 pb-3 d-flex h-100 ps-0 ms-0 g-0">
      <div
        className="bgForm h-100 ms-2 pt-4 d-flex justify-content-center align-item-center"
        style={{
          minWidth: "350px",
          maxWidth: "350px",
          overflow: "auto",
        }}>
        <Form
          ignoreModified={true}
          onSubmit={handleSubmit}
          initialValues={initialData}
          id="ocrform"
          key={JSON.stringify(initialData)}
          render={(formRenderProps) => {
            return (
              <FormElement name="ocrform" id="ocrform">
                <fieldset>
                  {formRenderProps.visited &&
                    formRenderProps.errors &&
                    formRenderProps.errors.VALIDATION_SUMMARY && (
                      <div className={"k-messagebox k-messagebox-error"}>
                        {formRenderProps.errors.VALIDATION_SUMMARY}
                      </div>
                    )}

                  <div className="mb-3">
                    <Label className="label">Matter</Label>
                    <div
                      style={{
                        borderRadius: "10px",
                        boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
                      }}>
                      <MattersCombobox
                        error={validationError && !matterRef}
                        onChangematter={onChangematter}
                        reset={resetmatter}
                        openMattersOnly={true}
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <Label className="label">Date</Label>
                    <DatePicker
                      className="datepicker"
                      value={dateselector}
                      onChange={onChangedateselect}
                      toggleButton={CalenderCustomToggleButton}
                    />
                  </div>
                  <div className="mb-3">
                    <SearchComboBox
                      customValidation={true}
                      name="officeBank"
                      cbType={CONSTANT.OB}
                      width="auto"
                      boxShadow={true}
                      customStyle={{
                        border:
                          validationError &&
                          !formRenderProps.valueGetter("officeBank") &&
                          "1px solid red",
                      }}
                    />
                  </div>
                  <div className="mb-3">
                    <Label className="label">Reference</Label>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Input
                        // required={true}
                        width={200}
                        value={reference}
                        onChange={(e) => {
                          setReference(e.target.value);
                        }}
                        style={{
                          border:
                            validationError && !reference
                              ? "1px solid red"
                              : "1px solid #e6e6e6",
                          boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 16px",
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-3 right-align">
                    <Label className="label">Amount</Label>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <NumericTextBox
                        // required={true}
                        width={300}
                        style={{
                          textAlign: "right",
                          border:
                            validationError && !amount
                              ? "1px solid red"
                              : "1px solid #e6e6e6",
                          boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 16px",
                        }}
                        value={amount}
                        onChange={(e) => {
                          setAmount(e.target.value);
                        }}
                        placeholder="0.00"
                        spinners={false}
                        format="n2"
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <SearchComboBox
                      name="feeEarner"
                      cbType={CONSTANT.FE}
                      // required={false}
                      customValidation
                      width="auto"
                      boxShadow={true}
                      customStyle={{
                        border:
                          validationError &&
                          !formRenderProps.valueGetter("feeEarner") &&
                          "1px solid red",
                      }}
                    />
                  </div>
                  <div className="mb-3">
                    <Label className="label">Payer</Label>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Input
                        // required={true}
                        width={200}
                        value={payer}
                        onChange={(e) => {
                          setPayer(e.target.value);
                        }}
                        style={{
                          border:
                            validationError && !payer
                              ? "1px solid red"
                              : "1px solid #e6e6e6",
                          boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 16px",
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <Label className="label">Details</Label>
                    <div
                      style={{
                        borderRadius: "10px",
                        boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
                      }}>
                      <TextArea
                        // required={true}
                        rows={4}
                        placeholder="Enter Details"
                        value={details}
                        onChange={(e) => {
                          setDetails(e.target.value);
                        }}
                        style={{
                          border:
                            validationError && !details ? "1px solid red" : "none",
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-3 d-flex justify-content-end">
                    <DocumentsUpload
                      progress={progress}
                      filesData={filesData}
                      onFileRemove={onFileRemove}
                      onUpload={handleUpload}
                      type={"OfficeCreditandAllocation"}
                      onError={() => {
                        const newFiles = filesData.splice(filesData.length, 1);
                        setFilesData([...newFiles]);
                      }}
                      reset={resetDocs}
                    />
                  </div>
                </fieldset>
              </FormElement>
            );
          }}
        />

        <Modalposting
          value={modalvalue}
          reset={() => {
            reset();
          }}
          closeModal={() => {
            setmodalvalue(false);
          }}
          component={"Posting"}></Modalposting>
      </div>

      <div className="flex-grow-1 overflow-auto h-100 d-flex flex-column">
        <TransactionPeriod />

        <div
          className="mx-3 mt-3 h-100 d-flex flex-column"
          style={{ minHeight: "110px" }}>
          <OfficeCreditGrid
            amountRef={amountRef}
            officeCreditList={officeCreditList}
            updateAllocations={updateAllocations}
            selectedData={handleSelectedData}
          />

          <div className="buttonstyle justify-content-end">
            <Button
              className="common-btn"
              form="ocrform"
              type="submit"
              disabled={loading}>
              Post
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OfficeCreditAndAllocations;
